import {ColorSchemeType} from 'platform/components';
import {getColorByPath, getSize} from 'platform/foundation';
import styled from 'styled-components';

import {getColorStripePathByScheme} from '../utils/getColorStripePathByScheme';

export const KanbanCardWrapper = styled.div<{color: ColorSchemeType}>`
  border-radius: ${({theme}) => theme.radii[theme.components.Card.borderRadius]};
  box-shadow: ${({theme}) => theme.shadows[theme.components.Card.elevation]};
  background-color: white;
  border-left: ${getSize(1)} solid
    ${({color, theme}) => getColorByPath(getColorStripePathByScheme(color), theme)};

  &:hover {
    box-shadow: ${({theme}) => theme.shadows.elevation_2};
    border-left: ${getSize(1)} solid
      ${({color, theme}) => getColorByPath(getColorStripePathByScheme(color, true), theme)};
  }
`;
